// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import routes from './router'
import VueRouter from 'vue-router'
import axios from 'axios'
import Vuex from 'vuex'
import store from './store/'
import VueLazyload from 'vue-lazyload' // 图片懒加载
import infiniteScroll from 'vue-infinite-scroll' // 无限滚动
import NProgress from 'nprogress' // 浏览器加载进度条
import 'nprogress/nprogress.css'
import 'font-awesome/css/font-awesome.css'
// Settings：全局变量的配置  PcLockr：优雅的本地存储  PcEncrypt：前端加密
import {PcLockr, utils} from 'util/'
import clipboard from 'clipboard'
import 'element-ui/lib/theme-chalk/index.css'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

// 公共
import Bus from 'src/vueBus'
// 公用过滤器
import filters from './filters'
import Mixin from './mixins'

import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Card,
    Input,
    Dialog,
    Button,
    Form,
    formItem,
    MessageBox,
    Message,
    icon,
    Loading,
    Radio,
    RadioButton,
    RadioGroup,
    Select,
    Option,
    Row,
    Col,
    Checkbox,
    Pagination,
    DatePicker,
    Backtop,
    Upload,
    Tag,
    CheckboxGroup,
    InputNumber,
    Popover,
    Scrollbar,
    Image,
    Timeline,
    TimelineItem,
    Tabs,
    TabPane,
    Table,
    TableColumn
} from 'element-ui'

const components = [
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Card,
    Input,
    Dialog,
    Button,
    Form,
    formItem,
    icon,
    Loading,
    Radio,
    RadioButton,
    RadioGroup,
    Select,
    Option,
    Row,
    Col,
    Checkbox,
    Pagination,
    DatePicker,
    Backtop,
    Upload,
    Tag,
    CheckboxGroup,
    InputNumber,
    Popover,
    Scrollbar,
    Image,
    Timeline,
    TimelineItem,
    Tabs,
    TabPane,
    Table,
    TableColumn
]

components.map(component => {
    Vue.use(component)
})

Vue.prototype.$pcMessageBox = MessageBox
Vue.prototype.$pcMessage = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$pcBus = Bus
Vue.prototype.$pcNProgress = NProgress
Vue.prototype.clipboard = clipboard

Vue.prototype.$PcLockr = PcLockr
Vue.prototype.$Util = utils

Vue.component(CollapseTransition.name, CollapseTransition)
Vue.use(infiniteScroll)
Vue.use(Vuex)
Vue.mixin(Mixin)
Vue.use(VueRouter)
Vue.use(VueLazyload, {
    error: '/image/img/error.png',
})

const router = new VueRouter({
    mode: 'history',
    root: '/',
    routes
})

router.beforeEach((to, from, next) => {
    NProgress.start()
    if (PcLockr.get('token')) {
        next()
    } else {
        if (to.fullPath !== '/forgetPwd' && to.fullPath !== '/login') {
            window.location.href = '/login'
        } else {
            next()
        }
    }
    window.scrollTo(0, 0)
    next()
})

router.afterEach(() => {
    NProgress.done()
})

Vue.prototype.$http = axios.create({
    timeout: 60000
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]))
Vue.config.productionTip = false

/* router.beforeEach((to, from, next) => {
}) */

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js